import { defineAbility } from '@casl/ability'

import { User } from '../../../models'
import { Roles, userHasRole } from '../../../helpers'

export default (user: User) => defineAbility((can) => {
    if (userHasRole(user, Roles.Contributor)) {
        can('Create', 'SupplierPhoneNumber')
        can('Edit', 'SupplierPhoneNumber')
        can('Delete', 'SupplierPhoneNumber')
        can('Update', 'SupplierPhoneNumber')
    }
})
